import { render } from "./ArticleNew.vue?vue&type=template&id=f0c531d0&scoped=true"
import script from "./ArticleNew.vue?vue&type=script&lang=js"
export * from "./ArticleNew.vue?vue&type=script&lang=js"

import "./ArticleNew.vue?vue&type=style&index=0&id=f0c531d0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c531d0"]])

export default __exports__